// User-facing citation rule (2026-08-28): technical dataset codes NEVER appear
// in visible text — human labels only; the code stays in payload + tooltip.
export const SOURCE_LABELS = {
  OECD: "OECD",
  EUROSTAT: "Eurostat",
  UN_TOURISM_VIA_OWID: "UN Tourism via OWID",
  ISTAT: "ISTAT",
  BANCA_D_ITALIA: "Banca d'Italia",
};

export const sourceLabel = (org) =>
  SOURCE_LABELS[org] || String(org || "").replace(/_/g, " ");

const DS = {
  "tour_occ_ninc": {
    en: "Nights spent at tourist accommodation, cities, annual",
    it: "Notti nelle strutture ricettive, città, annuale" },
  "urb_cpop1": {
    en: "City population (Urban Audit), 1 January",
    it: "Popolazione delle città (Urban Audit), 1° gennaio" },
  "urb_ctour": {
    en: "Culture and tourism in cities (Urban Audit), nights 2019",
    it: "Cultura e turismo nelle città (Urban Audit), notti 2019" },
  "tour_occ_nim": {
    en: "Nights spent at tourist accommodation, monthly",
    it: "Notti nelle strutture ricettive, mensile" },
  "tour_occ_nin2": {
    en: "Nights spent at tourist accommodation, regional (NUTS 2), annual",
    it: "Notti nelle strutture ricettive, regionale (NUTS 2), annuale" },
  "tour_occ_arn2": {
    en: "Arrivals at tourist accommodation, regional (NUTS 2), annual",
    it: "Arrivi nelle strutture ricettive, regionale (NUTS 2), annuale" },
  "tour_occ_nin2 / tour_occ_arn2": {
    en: "Nights & arrivals at tourist accommodation, regional (NUTS 2), annual",
    it: "Notti e arrivi nelle strutture ricettive, regionale (NUTS 2), annuale" },
  "tour_ce_omr": {
    en: "Guest nights booked via platforms (Airbnb, Booking, Expedia), experimental",
    it: "Notti prenotate via piattaforme (Airbnb, Booking, Expedia), sperimentale" },
  "tour_ce_omn12": {
    en: "Guest nights booked via platforms, regional (NUTS 2), experimental",
    it: "Notti via piattaforme, regionale (NUTS 2), sperimentale" },
  "122_54_df_dcsc_tur_3": {
    en: "Tourist flows in accommodation establishments, monthly",
    it: "Movimento clienti negli esercizi ricettivi, mensile" },
  "dsd_tourism_inter@df_inbound": {
    en: "Inbound tourism (international arrivals)",
    it: "Turismo inbound (arrivi internazionali)" },
  "dsd_tourism_receipts@df_receipts": {
    en: "Travel receipts (national currency)",
    it: "Entrate turistiche (valuta nazionale)" },
  "dsd_tourism_key@df_key_ind_pc": {
    en: "Key tourism indicators (share of GDP / employment)",
    it: "Indicatori chiave del turismo (quota PIL / occupazione)" },
  "international-tourist-trips": {
    en: "International tourist arrivals",
    it: "Arrivi turistici internazionali" },
  "international-tourist-departures": {
    en: "International tourist departures",
    it: "Partenze turistiche internazionali" },
  "spending-by-international-visitors-while-visiting-a-country": {
    en: "International visitor spending (USD)",
    it: "Spesa dei visitatori internazionali (USD)" },
  "spending-by-international-visitors-while-visiting-a-country-as-a-share-of-gdp": {
    en: "International visitor spending, share of GDP",
    it: "Spesa dei visitatori internazionali, quota del PIL" },
  "spending-by-a-countrys-residents-while-travelling-abroad": {
    en: "Outbound travel spending by residents (USD)",
    it: "Spesa all'estero dei residenti (USD)" },
  "international-tourist-arrivals-by-region-of-origin": {
    en: "Outbound trips by region of origin",
    it: "Viaggi in uscita per regione di origine" },
  "turismo_tavole": {
    en: "International tourism survey — published tables",
    it: "Indagine sul turismo internazionale — tavole" },
  "tour_ce_omn12 / 122_54_df_dcsc_tur_3": {
    en: "Platform guest nights (Eurostat) vs total nights (ISTAT)",
    it: "Notti via piattaforme (Eurostat) vs presenze totali (ISTAT)" },
};

// Unknown codes → null: caller shows the source only, code stays in tooltip.
export const datasetLabel = (code, lang = "en") => {
  const e = DS[String(code || "").trim().toLowerCase()];
  return e ? (lang === "it" ? e.it : e.en) : null;
};
